import { definirItemListener } from "@hooks/Analises/auxiliares/localStorageHelper";

export const salvarRascunhoIa = async (
  editorData,
  palavrasChave,
  metadescricao,
  html,
  mutateAsync
) => {
  const idArtigo = localStorage.getItem('id_artigo_ia') || '0';

  let { imagemBase64, alt } = dadosImagem(editorData);

  const titleBlock = editorData.blocks.find(block => block.type === 'header');
  const postTitle = titleBlock?.data?.text?.trim() || 'Novo artigo';

  const editorDataSemImagem = editorData.blocks.filter(
    block => block.type !== 'image' && block.type !== 'iaImage'
  );
  const editorDataSemImagemJson = JSON.stringify({ blocks: editorDataSemImagem });

  const response = await mutateAsync({
    action: 'salvar_rascunho_ia',
    param: {
      id: parseInt(idArtigo),
      titulo: postTitle,
      conteudo: editorDataSemImagemJson,
      html: html,
      palavras_chave: palavrasChave,
      imagem: imagemBase64,
      metadescricao: metadescricao,
      alt_imagem: alt,
    },
  });

  if (response?.data) {
    const rascunho = {
      id: response?.data?.id,
      titulo: postTitle,
      conteudo: editorDataSemImagemJson,
      html: html,
      palavras_chave: palavrasChave,
      imagem: imagemBase64,
      metadescricao: metadescricao,
      alt_imagem: alt,
    };

    definirItemListener('artigo_em_edicao', rascunho);
    localStorage.setItem('artigo_em_edicao', JSON.stringify(rascunho));
  }

  return response?.data;
};

export const converterParaBlocosGutenberg = (editorData = { blocks: [] }) => {
  if (!editorData?.blocks) return [];

  const titleBlock = editorData.blocks.find(block => block.type === 'header');
  const postTitle = titleBlock?.data?.text?.trim() || 'Novo artigo';

  const gutenbergBlocks = editorData.blocks
    .filter(block => block !== titleBlock)
    .map(block => {
      switch (block.type) {
        case 'header':
          return {
            blockName: 'core/heading',
            attrs: {
              level: block.data.level,
              content: block.data.text,
            },
          };
        case 'paragraph':
          return {
            blockName: 'core/paragraph',
            attrs: {
              content: block.data.text,
            },
          };
        case 'image':
          return {
            blockName: 'core/image',
            attrs: {
              url: block.data.url,
              caption: block.data.caption,
            },
          };
        default:
          return null;
      }
    })
    .filter(block => block !== null);

  localStorage.setItem('opti_editor_title', postTitle);
  return gutenbergBlocks;
};

const dadosImagem = (editorData = { blocks: [] }) => {
  const imagemBlock = editorData.blocks?.find(
    block => block.type === 'image' || block.type === 'iaImage'
  );

  let imagemBase64 = null;
  if (imagemBlock?.data?.url?.startsWith('data:image')) {
    imagemBase64 = imagemBlock.data.url.split(',')[1];
  }

  return { imagemBase64, alt: imagemBlock?.data?.caption };
};
